import { RequestActionType } from '@strata/react-chat';
import { WarningDialog } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';

import { RequestSummarySection } from 'components/requests/dialogs/RequestSummarySection';
import { type PayerRequestActionDialogProps } from 'services/interfaces';
import { usePostRequestActivityMutation } from 'store/api/payerRequestApi';

const Title = 'Cancel Request';

export const CancelRequestDialog = ({
    onClose,
    payerId,
    requestDetails,
}: PayerRequestActionDialogProps) => {
    const [postRequestActivity] = usePostRequestActivityMutation();
    return (
        <WarningDialog
            dialogTitle={`Confirm ${Title}`}
            width={600}
            isOpen
            secondaryButtonLabel="No, Return To Request Details"
            onSecondaryButtonClick={onClose}
            primaryButtonLabel={`Yes, ${Title}`}
            onPrimaryButtonClick={() => {
                void (async () => {
                    await postRequestActivity({
                        payerId,
                        requestId: requestDetails.requestId,
                        actionType: RequestActionType.CANCELED,
                    }).unwrap();

                    SuccessToast({ message: 'Request canceled successfully.' });
                    onClose();
                })();
            }}
            dialogContent={
                <>
                    <div className="margin__bottom--medium">
                        Are you sure you want to cancel this request?
                    </div>
                    <RequestSummarySection requestDetails={requestDetails} />
                </>
            }
        />
    );
};

CancelRequestDialog.Title = Title;
